export default {
  siteTitle:
    'ecomChicago 2018 | A 3-day Conference for Online Entrepreners and Store Owners',
  date: 'October 18th-20th',
};



// WEBPACK FOOTER //
// ./src/constants/content.js